import { LitElement, html } from 'lit';
import { Router } from '@lit-labs/router';

export class EplibAppRoot extends LitElement {
  _router = new Router(this, [
    {
      path: '/',
      render: () => html`<eplib-home-view></eplib-home-view>`
    },
    {
      path: '/home.html',
      render: () => html`<eplib-home-view></eplib-home-view>`
    },
    {
      path: '/exist/apps/shc/home.html',
      render: () => {
        this.fixURL();
        return html`<eplib-home-view></eplib-home-view>`;
      }
    },
    {
      path: '/index.html',
      render: () => html`<eplib-home-view></eplib-home-view>`
    },
    {
      path: '/works/',
      render: () => html`<eplib-browse-view></eplib-browse-view>`
    },
    {
      path: '/works/*',
      render: () => html`<eplib-content-view></eplib-content-view>`
    },
    {
      path: '/exist/apps/shc/works/',
      render: () => {
        this.fixURL();
        return html`<eplib-browse-view></eplib-browse-view>`;
      }
    },
    {
      path: '/exist/apps/shc/works/*',
      render: () => {
        this.fixURL();
        return html`<eplib-content-view></eplib-content-view>`;
      }
    },
    {
      path: '/review/',
      render: () => html`<eplib-review-view></eplib-review-view>`
    },
    {
      path: '/exist/apps/shc/review/',
      render: () => {
        this.fixURL();
        return html`<eplib-review-view></eplib-review-view>`;
      }
    },
    {
      path: '/digital-combos.html',
      render: () => html`<eplib-digital-combos-view></eplib-digital-combos-view>`
    },
    { 
      path: '/history.html',
      render: () => html`<eplib-history-view></eplib-history-view>`
    },
    { 
      path: '/libbuilding.html',
      render: () => html`<eplib-libbuilding-view></eplib-libbuilding-view>`
    },
    // make this default route last in the list
    {
      path: '/*',
      render: () => html`<eplib-home-view></eplib-home-view>`
    },
  ]);

  updated(changedProperties) {
    const routeEvent = new CustomEvent('eplib-route-changed', {
      bubbles: true,
      composed: true
    });
    window.dispatchEvent(routeEvent);
  }

  /* People seem to have regarded the /exist/apps/shc bleed-through as permanent links
   * and so we now have to have routes for them, but we edit the URL to make that part
   * disappear.
   */
  fixURL() {
    let url = window.location.href;
    url = url.replace('\/exist\/apps\/shc', '');
    if (url !== window.location.href) {
      history.replaceState(null, '', url);
      console.log("url is now: " + url);
    }
  }

  render() {
    return html`<main>${this._router.outlet()}</main>`;
  }
}

customElements.define('eplib-app-root', EplibAppRoot);